import React, { useState, useEffect } from 'react';
import Layout from './components/Layout/Layout';
import Request from './components/Workspace/Request/RequestPanel';
import Response from './components/Workspace/Response/ResponsePanel';
import LandingPage from './components/Landing/Landing';

const App = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('apiHistory');
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('apiKey');
  });

  useEffect(() => {
    localStorage.setItem('apiHistory', JSON.stringify(history));
  }, [history]);

  const handleLogin = (apiKey) => {
    localStorage.setItem('apiKey', apiKey);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('apiKey');
    setIsAuthenticated(false);
  };

  return (
    <>
      {!isAuthenticated ? (
        <Layout history={history} setHistory={setHistory} setSelectedRequest={setSelectedRequest}>
          <Request
            setResponse={setResponse}
            setLoading={setLoading}
            setHistory={setHistory}
            selectedRequest={selectedRequest}
          />
          <Response response={response} loading={loading} />
          <button
            className="fixed top-3 right-3 px-4 py-2 text-sm font-medium text-[#fdb814] border-2 border-[#fdb814] rounded-lg hover:bg-gradient-to-r hover:from-[#fdb814] hover:to-[#e5a50f] hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30 backdrop-blur-sm bg-white/90"
            onClick={handleLogout}
          >
            Logout
          </button>
        </Layout>
      ) : (
        <LandingPage onLogin={handleLogin} />
      )}
    </>
  );
};

export default App;